// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"85fc2007","453":"825386d9","549":"5d43927e","629":"3568a1bd","781":"f6579e04","984":"3a3d3eb8"}[chunkId] + ".chunk.js";
};